import { useTranslation } from "react-i18next";
import { setLocale, type UiLocale, uiLocales } from "../../app/i18n.js";
import { focusRing } from "../../ui/index.js";

const labels: Record<UiLocale, string> = { "sr-Latn": "SR", en: "EN", ru: "RU" };

/** Переключатель языка интерфейса: сегменты в сером поле, выбранный белый. */
export function LocaleSwitch() {
  const { i18n } = useTranslation();
  return (
    <div className="inline-flex w-fit gap-0.5 rounded-full bg-slate-100 p-0.5 text-xs font-semibold">
      {uiLocales.map((l) => (
        <button
          key={l}
          type="button"
          aria-pressed={i18n.language === l}
          onClick={() => setLocale(l)}
          className={`min-h-8 rounded-full px-3 transition ${focusRing} ${i18n.language === l ? "bg-white text-ink shadow-card" : "text-ink-2 hover:text-ink"}`}
        >
          {labels[l]}
        </button>
      ))}
    </div>
  );
}
